import React, { PureComponent } from "react";
import "../../Styles/RiskViews.scss";
import {
  Grid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import ColumnMenu from "../Dashboard/ColumnMenu";
import Api from "../../Services/Api";
import { CircularProgress } from "@material-ui/core";
import * as moment from "moment";
import ValidateNumberCell from "../Tasks/ValidateNumberCell";
export default class ValidateAction extends PureComponent {
  constructor(props) {
    super(props);
    this.state = this.createAppState({
      ...this.state,
      sort: [{ field: "code", dir: "asc" }],
      take: 20,
      skip: 0,
      mitigationData: [],
      impactMaster: [],
    });
  }
  componentDidMount() {
    this.getTemporaryActionListForUploader();
  }
 

  getTemporaryActionListForUploader=async()=>{
    try{
      this.setState({ ...this.state, loader: true });
      const requestParams = {
        workstreamId: this.props.workstreamId,
      };
      let response = await Api.getTemporaryActionListForUploader(requestParams);
      if (response.status === 200) {
        response.mitigationResps.map((actionObj)=>{
          if (actionObj.actualCompletionDate) {
            actionObj.actualCompletionDate = new Date(
              actionObj.actualCompletionDate
            );
          }
          if (actionObj.originalCompletionDate) {
            actionObj.originalCompletionDate = new Date(
              actionObj.originalCompletionDate
            );
          }
          if (actionObj.projectedCompletionDate) {
            actionObj.projectedCompletionDate = new Date(
              actionObj.projectedCompletionDate
            ); 
          }
          if (actionObj.proximityDate) {
            actionObj.proximityDate = new Date(actionObj.proximityDate);
          }
          
          if(actionObj.approved===true||actionObj.approved==="Yes"){
            actionObj["approved"] ="Yes";
          }else{
            actionObj["approved"] ="No";
          }
          if(actionObj.isOpen===true||actionObj.isOpen==="Open"){
            actionObj["isOpen"]="Open";
          }else{
            actionObj["isOpen"]="Closed";
          }
        
        });
        this.createDynamicCols(response.mitigationResps);
        this.props.handleValidateDataCount({
          newRiskCount:response.newActionCount,
          modifiedRiskCount:response.modifiedActionCount,
          closedRiskCount:response.closedActionCount
        });
        this.setState({ ...this.state, loader: false });
      }else{
        this.setState({ ...this.state, loader: false });
        this.props.handleValidateDataCount({
          newRiskCount:response.newActionCount,
          modifiedRiskCount:response.modifiedActionCount,
          closedRiskCount:response.closedActionCount
        });
      }
    }catch(err){
      console.log(err);
      this.setState({ ...this.state, loader: false });
    }
  }

  createDynamicCols = async (products) => {
    try {
      let impactMaster = [];
      if (products && products.length > 0) {
        impactMaster = products[0].impactResponse;
      }

      let impactColumn = [];

      products.map((res, i) => {
        if (res.impactResponse) {
          res.impactResponse.map((item, j) => {
            if (impactColumn.length > 0) {
              if (!impactColumn.includes(item.name)) {
                impactColumn.push(item.name);
              }
            } else {
              impactColumn.push(item.name);
            }
          });
        }
      });
 
      if (impactColumn.length > 0) {
        products.map((res) => {
          impactColumn.map((col) => {
            let temp = res.impactResponse.find((item) => item.name === col);
            if (temp) {
              res[col] =
                temp.impactType == "Quantitative" ? temp.value : temp.qValue;
            } else {
              res[col] = undefined;
            }
          });
        });
      }
      let columnsToShow = [];
      if (impactColumn.length > 0) {
        columnsToShow = impactColumn.map((item) => (
          <Column
            field={item}
            title={"Change in " + this.getImpactUnit(item, impactMaster)}
            width="100px"
            editable={false}
            filter={"numeric"}
            columnMenu={ColumnMenu}
            // cell={(props) => (
            //   <CurrencyFormat {...props} onEditCell={this.onEditCell} />
            // )}
          />
        ));
      }
      this.setState({
        ...this.state,
        impactColumns: columnsToShow,
        mitigationData: products,
        mitigationDataTemp: products,
      });
    } catch (err) {
      console.log(err);
    }
  };

  getImpactUnit = (impact, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == impact);
    var res = impact;
    if (
      impactTemp &&
      impactTemp.name &&
      impactTemp.impactType == "Quantitative"
    ) {
      // let units=impactTemp.isCurrency?impactTemp?.currency?.currencyCode:impactTemp.units;
      res = impactTemp.name + " / " + impactTemp.units;
    }
    return  res;
  };

  dataStateChange = (event) => {
    this.setState(this.createAppState(event.dataState));
  };

  createAppState = (dataState) => {
    if (this.state && this.state.mitigationDataTemp) {
      return {
        mitigationData: this.state.mitigationDataTemp.slice(0),
        dataState: dataState,
      };
    } else {
      return {
        mitigationData: [],
        dataState: dataState,
      };
    }
  };
  onEditCell = () => {};
  validate_rowRender = (row, rowProps) => {
    let backgroundColor = "";
    let fontWeight = "";
    let fontSize = "12px";
    if (rowProps.dataItem.isUncommit === true) {
      backgroundColor = "#301934";
      fontWeight = "bold";
      fontSize = "16px";
    }
    // else if(rowProps.dataItem.isClosedExcelUpdate === true) {
    //   backgroundColor = "#428fed";
    //   fontWeight = "bold";
    //   fontSize = "16px";

    // }
   
    return React.cloneElement(
      row,
      {
        ...row.props,
        style: {
          ...row.props.style,
          backgroundColor: backgroundColor,
          fontWeight: fontWeight,
          fontSize: fontSize,
        },
      },
      row.props.children
    );
  };
   validate_cellRender = (row, cellProps) => {
    const cellField = cellProps.field;
    var dataItem = cellProps.dataItem;
    const cellValue = dataItem[cellField];
    let backgroundColor = "";
    let fontWeight = "";
    let fontSize = "12px";
    if (dataItem.updatedColumnsFromExcel&&dataItem.updatedColumnsFromExcel.includes(cellField)) {
      backgroundColor = "#034f0e";
      fontWeight = "bold";
      fontSize = "16px";
    }
    // else if(dataItem.isClosedExcelUpdate===true && cellField==='number'){
    //   backgroundColor = "#428fed";
    //   fontWeight = "bold";
    //   fontSize = "16px";
    // }
    if(this.checkDate(cellValue)){
      dataItem[cellField]=cellValue?moment(cellValue).format('DD-MMM-YYYY'):'';
    }
  return React.cloneElement(
    row,
    {
      ...row.props,
      style: {
        ...row.props.style,
        backgroundColor: backgroundColor,
        fontWeight: fontWeight,
          fontSize: fontSize,
      }
    },
    row.props.children
  );
  };
  checkDate = (dateString) => {
    if(dateString&&dateString!=''){
      return moment(dateString, 'DD-MMM-YYYY', true).isValid();
    }
    return false;
  };
  render() {
    return (
      <div
        className="tblCont riskRegister dataGrids reportsGrid"
        id="reportaction"
      >
        {this.props.loader || this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}
        <Grid
          data={process(this.state.mitigationData, this.state.dataState)}
          {...this.state.dataState}
          onDataStateChange={this.dataStateChange}
          rowRender={this.validate_rowRender}
          cellRender={this.validate_cellRender}
          reorderable
          resizable
          sortable={true}
          pageable={true}
        >
          
          <Column field="number" title="Action Number" width="120px" locked={true}
           cell={ValidateNumberCell}/>
          <Column field="name" title="Action Title" width="200px" />
          <Column field="riskNumber" title="Risk Number" width="200px"  />
          <Column field="riskTitle" title="Risk Title" width="200px" />
          <Column
            field="approved"
            title="Approved"
            filter={"boolean"}
            width="100px"
          />
          <Column field="control" title="Description" width="150px" />
          <Column
            field="externalReference"
            title="External Reference"
            width="150px"
          />
          <Column field="actionType" title="Action Type" width="150px" />
          <Column
            field="cost"
            title={"Cost of Action"}
            width="80px"
          />
          <Column
            field="reductionFrequency"
            width="80px"
            title="Change in Probability (%)"
          />
          {this.state.impactColumns}
          <Column
            field="spi"
            title="% On Track"
            width="80px"
            filter={"number"}
          />
          <Column
            field="percentageCompletion"
            title="% Completion"
            width="100px"
          />
          <Column
            field="originalCompletionDate"
            width="100px"
            title="Original Completion Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="projectedCompletionDate"
            width="100px"
            title="Projected Completion Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="actualCompletionDate"
            width="100px"
            title="Actual Completion Date"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="proximityDate"
            title="Proximity Alert Date"
            width="100px"
            filter={"date"}
            format="{0:dd-MMM-yyyy}"
          />
          <Column
            field="delayConsequence"
            title="Delay Consequence"
            width="150px"
          />
          <Column
            field="alertDescription"
            title="Alert Description"
            width="130px"
          />
          <Column
            field="actionAlertStakeHolders"
            title="Alert StakeHolders"
            width="130px"
          />
          <Column field="owner" title="Owner" width="100px" />

          <Column field="status" width="100px" title="Progress Status" />
          <Column field="isOpen" title="Status" width="80px" editor="boolean" />
          
          <Column field="departments" title="Departments" width="150px"/>
          <Column field="externalStatus" title="External Status" width="120px"/>
          <Column field="weeklyReport" title="Weekly Report" width="100px"/>
        </Grid>
      </div>
    );
  }
}
